
<template>
    <v-app style="background-color: #F2E7D5; color:black; ">
        <cabecera/>
        <v-main style="background-color: #F2E7D5 !important; color:black; ">
            <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />

        <section  style="height: 500px; background-color:#393E46; "   >

            <v-row
                    align="center"
                    justify="center"
            >
          <v-col
                  class="text-center mt-4"
                  cols="11"
                  lg="6"
                  md="6"
                  sm="10"
                  style="height: 100px;"
          >
              <h1 class="text-lg-h1  text-justify text-md-h1 text-sm-h1 text-h2 font-weight-bold" style="color: white;" >
               Discotecas
            </h1>
              <h1 class="text-lg-h1   text-justify text-md-h1 text-sm-h1 text-h2 font-weight-bold textogradiente"  >
                  &
              </h1>
              <h1 class="text-lg-h1   text-justify text-md-h1 text-sm-h1 text-h2 font-weight-bold" style="color: white;" >
                  Bares
              </h1>
              <h6 class="subheading text-justify text-lg-h6 text-md-h6 text-sm-h6 text-h6 mt-lg-0 mt-md-0 mt-sm-0 mt-6" style="color: white;">
Tunay es la forma más segura, práctica y transparente para manejar su Discoteca.<br />
              La forma fácil y rápida para el ingreso de sus invitados, así como el manejo de sus relaciones públicas.
            </h6>
          </v-col>


        </v-row>



    </section>

      <section class="pt-6">

        <v-row class="text-center" justify="center" align="stretch">
          <v-col cols="10" xl="3" lg="3" class="text-start d-flex flex-column">
<v-card rounded light color="#EFE5E2" class="rounded-xl elevation-8 flex d-flex flex-column">
    <v-card-title class="text-center text-h4 ">Administradores</v-card-title>
    <v-card-text class="text-justify text-h6 flex">
<ul>
    <li>Administración de Fiestas</li>
    <li>Administración de Promotores</li>
    <li>Administración de Clientes</li>
    <li>Administración de Listas</li>
    <li>Administración de Zonas</li>
    <li>Administración de Reservas</li>
    <li>Reportes</li>
</ul>
    </v-card-text>
</v-card>
          </v-col>
            <v-col cols="10" xl="3" lg="3" class="text-start d-flex flex-column">
                <v-card rounded light color="#EFE5E2" class="rounded-xl elevation-8 flex d-flex flex-column">
                    <v-card-title class="text-center text-h4">Promotores</v-card-title>
                    <v-card-text class="text-justify text-h6 flex">
                        <ul>
                            <li>Ingreso de Listas</li>
                            <li>Generación de QRs</li>
                            <li>Cabezas de Equipos de Promotores</li>
                            <li>Reporte de ingreso de sus invitados</li>
                        </ul>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="10" xl="3" lg="3" class="text-start d-flex flex-column">

                <v-card rounded light color="#EFE5E2" class="rounded-xl elevation-8 flex d-flex flex-column">
                    <v-card-title class="text-center text-h4">Clientes</v-card-title>

                    <v-card-text class="text-justify text-h6 flex">
                        <ul>
                            <li>Descargar tu QR en Pdf o Wallet</li>
                            <li>Carnet Digital para tu Membresia</li>

                        </ul>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
      </section>
    </v-main>
    <piepagina/>
  <v-overlay :value="overlay">
    <v-img
        src="@/assets/loadtunay.gif"

    />
  </v-overlay>


  </v-app>
</template>

<script>
import axios from 'axios';


import cabecera from '../general/cabecera';
import piepagina from '../general/piepagina';
import moment from "moment-timezone";
import {mapGetters} from "vuex";
import store from "@/store";
import Cabecerabaja from "@/components/general/cabecerabaja";


  export default {
    name: 'baresydiscos',
    title: 'Tunay Mi acceso de bolsillo',
    components: {
      Cabecerabaja,
    cabecera,
    piepagina,
  },
    data () {
      return {
        fiestas: [],
        eventos: [],
        email: '',
        tab: null,
        codigoUnico:'',
        rese:'',
        overlay:false,
        emailRules: [
          v => !!v || 'Se necesita el Email',
          v => /.+@.+/.test(v) || 'E-mail debe ser valido',
        ]
          }
    },
    mounted(){
      if(this.usuario.id>0){
        store.dispatch("conectarse")
      }
      this.traeClientes()
      this.fnBrowserDetect();
    },
    methods: {
      validarcodigo(){
        if(this.codigoUnico!= ''){
        this.$router.push({name:"validaqr",params:{codigo: this.codigoUnico}})
        }
      },
      fnBrowserDetect(){

        let userAgent = navigator.userAgent;

        if(userAgent.match(/chrome|chromium|crios/i)){
          this.rese = "chrome";
        }else if(userAgent.match(/firefox|fxios/i)){
          this.rese = "firefox";
        }  else if(userAgent.match(/safari/i)){
          this.rese = "safari";
        }else if(userAgent.match(/opr\//i)){
          this.rese = "opera";
        } else if(userAgent.match(/edg/i)){
          this.rese = "edge";
        }else{
          this.rese="No browser detection";
        }

      },

      formatDatee(value) {
        return moment(value).locale('es-pe').format("DD MMMM YYYY")
      },
      traeClientes(){
        this.overlay = true;
       axios.get("actos/activas", {
         headers: {
           'Accept': 'application/json',
           'Content-Type': 'application/json;charset=UTF-8'
         }
      })
      .then((response)  => {
        this.fiestas = response.data.filter(x=>x.temporada != null);
        this.eventos = response.data.filter(x=>x.temporada == null)
        this.overlay = false;
      })
      .catch((error)  => {
        console.log(error);
        this.overlay = false;
      });
    },

    },
    computed: {
      // map `this.user` to `this.$store.getters.user`
      ...mapGetters({
        usuario: "usuario",
        conectado: "conectado"
      })
    }
  }
</script>
<style scoped>
.textogradiente {

    background: -webkit-linear-gradient(#eee, #333);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
</style>